import React from "react";
import { CheckCircle, WarningCircle, Lock, Flag, Circle, HourglassMedium, ArrowUp, ArrowDown } from "@phosphor-icons/react";

const MAP = {
  matched:           { cls: "badge-matched",  label: "Matched",           icon: CheckCircle },
  locked_awaiting_head_counter: { cls: "badge-locked", label: "Locked — Head Counter",  icon: Lock },
  finalized_by_head_counter:    { cls: "badge-final",  label: "Finalized",  icon: Flag },
  pending:           { cls: "badge-pending",  label: "Pending",           icon: Circle },
  in_progress:       { cls: "badge-progress", label: "In Progress",       icon: HourglassMedium },
  // counter UI-side aliases
  open:              { cls: "badge-pending",  label: "Awaiting Count",    icon: Circle },
  locked:            { cls: "badge-locked",   label: "Locked",            icon: Lock },
};

/**
 * Renders a status badge. If status is `recount_required` (admin/head-counter)
 * or `recount_required` on counter view, we swap label to "Over"/"Short"
 * based on `direction` ("over" | "short" | "match" | undefined).
 */
export default function StatusBadge({ status, direction, size = "sm", className = "", testid }) {
  let label, cls, Icon;
  if (status === "recount_required" || (status === "open" && direction && direction !== "match")) {
    if (direction === "over") {
      cls = "badge-over"; label = "Over"; Icon = ArrowUp;
    } else if (direction === "short") {
      cls = "badge-short"; label = "Short"; Icon = ArrowDown;
    } else {
      cls = "badge-recount"; label = "Recount"; Icon = WarningCircle;
    }
  } else {
    const s = MAP[status] || MAP.pending;
    cls = s.cls; label = s.label; Icon = s.icon;
  }
  const px = size === "lg" ? "px-3 py-1 text-sm" : "px-2 py-0.5 text-xs";
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-sm font-medium tracking-wide ${px} ${cls} ${className}`}
      data-testid={testid || `status-${status}${direction ? `-${direction}` : ""}`}
    >
      <Icon weight="fill" className={size === "lg" ? "w-4 h-4" : "w-3.5 h-3.5"} />
      {label}
    </span>
  );
}
